import { ApiClient, apiClient } from 'src/utils/api-client';

type StartOTPFlowDto = {
  connection: 'Sms' | 'Email' | 'MaskedEmailSession';
  send: 'Code' | 'MagicLink';
  requestSource: 'InspectorApp' | 'Consumer';
  phoneNumber?: string;
  email?: string;
  maskedEmailSessionId?: string;
  maskedChosenKey?: number;
  userId?: number;
  redirectUrl?: string;
};

type StartOTPFlowResultDto = {
  sessionId: string;
  timeWindowSizeSeconds?: number;
  otp?: string;
  magicLink?: string;
};

export function startOTPFlowService(
  body: StartOTPFlowDto,
  client: ApiClient = apiClient,
) {
  return client.post<StartOTPFlowResultDto>(
    `/v2/users/consumer/otp/start`,
    body,
  );
}

type VerifyOTPCodeDto = {
  GrandType: 'Otp';
  Otp: string;
  SessionId: string;
  Realm: 'Code' | 'MagicLink';
  UserSourceTypeModel: 'BelongX' | 'Platform' | 'BelongInspector';
  PhoneNumber?: string;
  Email?: string;
  MaskedEmailSessionId?: string;
  UserId?: number;
};

type VerifyOTPCodeResultDto = {
  token: string;
  expiration: string;
  refreshToken: string;
};

export function verifyOTPCodeService(
  body: VerifyOTPCodeDto,
  client: ApiClient = apiClient,
) {
  const formData = new FormData();

  Object.entries(body).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });

  return client.post<VerifyOTPCodeResultDto>(
    '/v2/users/consumer/oauth/token',
    formData,
    {
      jsonContent: false,
    },
  );
}

type GetMaskedEmailsBySessionIdDto = {
  sessionId: string;
};

export type MaskedEmails = {
  [userId: string]: string;
};

type GetMaskedEmailsBySessionIdResultDto = {
  maskedEmails: MaskedEmails;
};

export function getMaskedEmailsBySessionIdService(
  { sessionId }: GetMaskedEmailsBySessionIdDto,
  client: ApiClient = apiClient,
) {
  return client.get<GetMaskedEmailsBySessionIdResultDto>(
    `/users/otp/masked-email/${sessionId}`,
  );
}
